import { CDN_UPDATE_LOCAL_BROWSER_STATS } from '../constants/ActionTypes';

export function updateLocalBrowserStats(path, cdnKey, stats) {
    return {
        type: CDN_UPDATE_LOCAL_BROWSER_STATS,
        path,
        cdnKey,
        stats
    };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/CdnActions.js
 **/